const updateLabel = e => {
  const input = e.target || e;
  const fieldWrap = input.closest('.Form__Element');
  const label = fieldWrap?.querySelector('.Form__Element__Caption');
  if (label) {
    if (input.value || input === document.activeElement) {
      label.classList.add('is-active');
    } else {
      label.classList.remove('is-active');
    }
  }
};

const addFormLabelsPlaceholder = el => {
  const form = el.querySelector('.Form__MainBody');
  if (!form) return;
  const inputs = form.querySelectorAll('input');
  const textareas = form.querySelectorAll('textarea');
  const labels = form.querySelectorAll('.Form__Element__Caption');
  labels?.forEach(label => {
    if (label && label.nextElementSibling.tagName.toLowerCase() === 'select') {
      label.classList.add('select-label');
    }
  });

  inputs?.forEach(input => {
    input.addEventListener('focus', updateLabel);
    input.addEventListener('blur', updateLabel);
    input.addEventListener('input', updateLabel);
    updateLabel(input);
  });

  textareas?.forEach(textarea => {
    textarea.addEventListener('focus', updateLabel);
    textarea.addEventListener('blur', updateLabel);
    textarea.addEventListener('input', updateLabel);
    updateLabel(textarea);
  });
};

export default addFormLabelsPlaceholder;
